<div class="container">
  <div class="billing-container">
    <div class="w-full">
      <app-payment-stripe *ngIf="stripeConfig" [config]="stripeConfig"></app-payment-stripe>
    </div>
    <div class="order-summary-container">
      <div class="summary-container">
        <!-- Items -->
        <div class="agreement-container">
          <h2 class="total-amount-text">Total Amount: </h2><span style="margin-left: 10px;">{{ totalAmount / 100 | currency:currencyCode}}</span>
          <p>Total order amount includes VAT.  <a class="details-link" href="#">Show details</a></p>
          <label class="agreement-checkbox" nz-checkbox [nzChecked]="agreementChecked" (nzCheckedChange)="updateAgreement($event)">
            I request immediate access to my purchase and acknowledge that I will not be able to cancel my purchase once I receive my key
          </label>
          <button nz-button nzType="primary" type="submit" (click)="confirmPayment()">
            Order & Pay <span nz-icon nzType="ng-zorro:lock"></span>
          </button>
          <div>
          <div *ngIf="gateway === 'STRIPE'" class="powerd-by-stripe-container flex-end">
            <span nz-icon nzType="ng-zorro:powerd_by_stripe"></span>
          </div>
      </div>
    </div>
  </div>
</div>
